import { POST } from '../index';
import { USER_URL } from '../config';

/**
 * 用户登录
 * @param username 用户名
 * @param password 密码
 * @returns 用户信息
 */
export function user_authUserInfo_api(username: string, password: string) {
  return POST(`${USER_URL}/authUserInfo`, { username, password });
}
/**
 * 获取公钥
 */
export function user_securityInfo_api() {
  return POST(`${USER_URL}/securityInfo`);
}
